module.exports = __webpack_public_path__ + "img/employee_2.9846a14f.jpg";